import React from 'react';
import { useTranslation } from 'react-i18next';
import ParentStyled from './style';
import { loadStyle } from 'globalutils/fmUtils';
import { formatTime } from './utils';
import { checkServiceProvider } from './serviceProviderConfig';

let Styled = loadStyle(ParentStyled, 'pages/web/Dashboard');

const PotentialViolations = ({ potentialViolations, heading, other }) => {
  const { i18n } = useTranslation();

  return (
    <Styled.DriverDashboard newUI={checkServiceProvider('notification_newUI', window.$environment.SERVICE_PROVIDER, false)}>
      {heading ? (
        <div className={`dashboardComponents ${other ? 'otherHeading' : 'dashboardViolation'}`}>
          <div className="headingsWrapper">
            <span className="mainHeading">{i18n.t(heading)}</span>
          </div>
        </div>
      ) : (
        ''
      )}
      {!potentialViolations.length ? (
        <span className="noDatavioltion">{i18n.t('No data available')}</span>
      ) : (
        <ul>
          {potentialViolations?.map((item) => {
            return item.items ? (
              <li>
                <span className="name">{item.items ? item.items[0] : item.driver || ''}</span>
                <span className="id">(ID:{item.items ? item.items[1] : item.id || ''})</span>
                <span className="message">{item.items ? item.items[3] : item.description || ''}</span>
              </li>
            ) : other ? (
              <li>
                <span className="name">{item.label}</span>
                <span className="message">{item.value}</span>
              </li>
            ) : (
              <li>
                <span className="name">{formatTime(item.date)}</span>
                <span className="message">{i18n.t(item.description)}</span>
              </li>
            );
          })}
        </ul>
      )}
    </Styled.DriverDashboard>
  );
};

export default PotentialViolations;

PotentialViolations.defaultProps = {};

PotentialViolations.propTypes = {};
